/**
 * **H Hotels**
 */
const factory = function factory({ window, thn }) {
    const updateSiteOnDataLayerEvents = (data) => {
        const message = data.message;
        if (message?.hotelId) {
            thn.siteCheck().catch(() => { });
        }
    };
    const hyperionDictionary = {
        'HYPERION Hotel Berlin': '15314',
        'HYPERION Hotel Leipzig': '32629',
        'HYPERION Hotel München': '32628',
        'HYPERION Hotel Salzburg': '32630',
        'HYPERION Hotel Basel': '15756',
        'HYPERION Hotel Dresden am Schloss': '32626',
        'HYPERION Hotel Garmisch-Partenkirchen': '80006',
        'HYPERION Hotel Hamburg': '20003',
    };
    return {
        getId() {
            return '329';
        },
        check() {
            return !!window.location.hostname.match(/h-hotels/);
        },
        boot() {
            thn.bus.on('dataLayer:push', updateSiteOnDataLayerEvents, true);
        },
        shutdown() {
            thn.bus.detach('dataLayer:push', updateSiteOnDataLayerEvents);
        },
        getSiteId() {
            const beUrl = document.querySelector('.teaserGallery__navigation__list__item__footer__link')?.href;
            const hotelIdFromWindow = window?.kp_product_id || window._jts?.find(object => object.id)?.id;
            let hotelId = document.querySelector('#hotel-code')?.value || hotelIdFromWindow || thn.dataLayerHelper.get('hotelId') || (window.location.pathname !== '/' && beUrl?.match(/\/hotel\/(\d+)/)?.[1]);
            // Hyperion hotels have different hotel ids in the booking engine and homepage
            const isHyperionBrand = window.location.pathname.match(/hyperion/);
            const isHomepage = !window.location.hostname.match(/secure/);
            if (isHomepage && isHyperionBrand && hotelId) {
                hotelId = hyperionDictionary[hotelId];
            }
            const result = hotelId ? { externalId: hotelId } : { accountKey: '494F99A289B0EC7E99803C52EF467539' };
            return result;
        },
    };
};

export { factory };
